// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"9031c05f","977":"5404d1a0"}[chunkId] + ".chunk.js";
};